import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function RetentionInfoBox() {
  return (
    <Box
      sx={{
        backgroundColor: '#E3F2FD',
        border: '1px solid #90CAF9',
        borderRadius: 2,
        p: 2.5,
        mt: 2,
        display: 'flex',
        gap: 1.5,
      }}
    >
      <InfoOutlinedIcon
        sx={{
          color: '#1976D2',
          fontSize: 24,
          flexShrink: 0,
          mt: 0.2,
        }}
      />
      <Box>
        <Typography
          variant="body2"
          sx={{
            color: '#1565C0',
            fontWeight: 600,
            mb: 1,
            lineHeight: 1.6,
          }}
        >
          DAY n은 각각 n일차에 룰렛에 진입한 사용자 수, 해당 사용자 수 중 티켓 적립을 한 사용자 수를
          나타냅니다.
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2.5, color: '#1565C0' }}>
          <Typography
            component="li"
            variant="body2"
            sx={{
              color: '#1565C0',
              lineHeight: 1.8,
              mb: 0.5,
            }}
          >
            <Box component="span" sx={{ fontWeight: 600 }}>
              첫째 줄:
            </Box>{' '}
            신규 사용자 기준으로,{' '}
            <Box component="span" sx={{ fontWeight: 600 }}>
              룰렛에
            </Box>{' '}
            진입한 사용자 수
          </Typography>
          <Typography
            component="li"
            variant="body2"
            sx={{
              color: '#1565C0',
              lineHeight: 1.8,
            }}
          >
            <Box component="span" sx={{ fontWeight: 600 }}>
              둘째 줄:
            </Box>{' '}
            신규 사용자 기준으로,{' '}
            <Box component="span" sx={{ fontWeight: 600 }}>
              룰렛에
            </Box>{' '}
            진입하여 티켓 적립을 1번이라도 한 사용자 수
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
